import { createBlueprint as a } from "@made-people/blueprint";
const t = a({
  slots: {
    base: ""
  },
  variants: {
    aspectRatio: {
      portrait: {
        base: "aspect-portrait h-auto max-h-none"
      },
      tall: {
        base: "aspect-tall h-auto max-h-none"
      },
      square: {
        base: "aspect-square h-auto max-h-none"
      },
      landscape: {
        base: "aspect-landscape h-auto max-h-none"
      },
      wide: {
        base: "aspect-wide h-auto max-h-none"
      },
      "ultra-wide": {
        base: "aspect-ultra-wide h-auto max-h-none"
      },
      panorama: {
        base: "aspect-panorama h-auto max-h-none"
      },
      auto: {
        base: "aspect-[var(--aspect-ratio-mobile)] md:aspect-[var(--aspect-ratio-tablet)] lg:aspect-[var(--aspect-ratio-desktop)] h-auto max-h-none"
      },
      "full-height-reveal": {
        base: "h-[100vh] max-h-[calc(100vh-200px)]"
      }
    }
  }
});
export {
  t as mediaBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
